import { translate } from "app/filters/i18nFilter";
import withSignalLifeCycleTag from "app/pages/sales-intelligence/sub-modules/signals/hoc/withSignalLifeCycleTag";
import type SignalFilters from "app/pages/sales-intelligence/sub-modules/signals/models/core/SignalFilters";
import type SignalTemplate from "app/pages/sales-intelligence/sub-modules/signals/models/templates/SignalTemplate";
import type TrafficSignalFilters from "app/pages/sales-intelligence/sub-modules/signals/models/traffic/TrafficSignalFilters";
import TrafficSignalSubType from "app/pages/sales-intelligence/sub-modules/signals/models/traffic/TrafficSignalSubType";
import type SignalFiltersViewProps from "app/pages/sales-intelligence/sub-modules/signals/models/view/SignalFiltersViewProps";
import type { ReactElement } from "react";
import SignalTemplateDetailedDropdownItem from "../../../shared/SignalTemplatesDropdown/SignalTemplateDetailedDropdownItem";
import SignalInsightTooltip from "../../../tooltips/SignalInsightTooltip/SignalInsightTooltip";
import SignalInsightTooltipContent from "../../../tooltips/SignalInsightTooltip/SignalInsightTooltipContent/SignalInsightTooltipContent";
import { StyledTemplateLabel, StyledViewHeader } from "../styles";

const DROPDOWN_WITH = 352;
const DROPDOWN_HEIGHT = 300;

type Props = Pick<SignalFiltersViewProps<Partial<TrafficSignalFilters>>, "signalSubType" | "renderTemplateView"> & {
    onTemplateSelect(template: Readonly<SignalTemplate<SignalFilters>>): void;
};

const TrafficSignalFiltersViewHeader = (props: Props) => {
    const renderInsightView = (): ReactElement | null => {
        switch (props.signalSubType) {
            case TrafficSignalSubType.NewMarkets:
                return (
                    <SignalInsightTooltip
                        title={translate("si.signals.insight.how-to-use.title")}
                        content={
                            <SignalInsightTooltipContent
                                title={translate("si.signals.insight.use-signal.title")}
                                description={translate(
                                    `si.signals.insight.use-signal.${props.signalSubType}.description`,
                                )}
                            />
                        }
                    />
                );
            default:
                return null;
        }
    };

    return (
        <StyledViewHeader>
            <StyledTemplateLabel text={translate("si.signals.management.label.traffic")}>
                {props.renderTemplateView({
                    dropdownPopupWidth: DROPDOWN_WITH,
                    dropdownPopupHeight: DROPDOWN_HEIGHT,
                    renderItem: withSignalLifeCycleTag(SignalTemplateDetailedDropdownItem),
                    onSelect: props.onTemplateSelect,
                })}
            </StyledTemplateLabel>

            {renderInsightView()}
        </StyledViewHeader>
    );
};

export default TrafficSignalFiltersViewHeader;
